import { render, staticRenderFns } from "./imageMultiSetting.vue?vue&type=template&id=63279710&scoped=true&"
import script from "./imageMultiSetting.vue?vue&type=script&lang=js&"
export * from "./imageMultiSetting.vue?vue&type=script&lang=js&"
import style0 from "./imageMultiSetting.vue?vue&type=style&index=0&id=63279710&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63279710",
  null
  
)

export default component.exports